/*
 * Copyright (c) 2025 Ipivot Corporation.
 * All rights reserved.
 * This software is the confidential and proprietary information of
 *  Ipivot Corporation ("Confidential Information").
 */
import * as dio from '../data';

/*
 * Backend context:
 *     - Working set cache
 */
import { createContext } from 'react';

export class BeContextType {
    beSelection: object;
    setBeSelection: any;
    setBeRefresh: any;
    globalFilter: any;   // filter from FingerTable
    setGlobalFilter: any;

    constructor() {
        this.beSelection = {};
    }

    count() {
        return Object.keys(this.beSelection).length;
    }

    async selPut(beSelection: object) {
        await dio.setBeSelection(beSelection);
        this.setBeRefresh(true);
    }
    async selRefresh() {
        let rc = await dio.getBeSelection();
        if (this.setGlobalFilter) {
            this.setGlobalFilter({... this.globalFilter});
        }
        this.setBeSelection(rc);
    }
    async selSetOne(fid: number, checked: boolean) {
        let rc = await dio.getBeSelection();
        if (checked) {
            rc[fid] = true;
        } else {
            delete rc[fid];
        }
        await dio.setBeSelection(rc);
        this.setBeRefresh(true);
    }
};

let ctx = new BeContextType();

export const BeContext = createContext<BeContextType>(ctx);